import { makeStyles } from "@material-ui/core/styles";

export const useInvestigationStyles = makeStyles((theme) => ({
  leftList: {
    height: 390,
    overflowY: "auto",
    paddingTop: 0,
  },
  rightList: {
    height: 450,
    overflowY: "auto",
    paddingTop: 0,
    width: "100%",
  },
  rightGridList: {
    maxHeight: 450,
    overflowY: "auto",
    paddingTop: 0,
    width: "80%",
  },
  listItem: {
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
  },
  gridListSmaller: {
    maxHeight: 300,
    overflowY: "auto",
    paddingTop: 0,
    width: "80%",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    background: "white",
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 10,
  },
  gridListContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
      },
      "&.Mui-focused fieldset": {
        border: `0px solid white`, // focus
      },
    },
    flex: 6,
  },
  answer: {
    backgroundColor: "#C4C4C4",
    marginTop: 20,
  },
  title: {
    marginTop: 10,
    marginBottom: 5,
    textAlign: "center",
  },
}));
